import React from 'react';
import { Button, Modal } from 'antd';
import { confirmArchive, confirmRestoreArchive } from '../popup/confirm';
const confirm = Modal.confirm;

const BtnArchiveEmployee = ({ isArchive, handleClick }) => {
  const confirmPopup = () => {
    confirm({
      ...(isArchive ? confirmRestoreArchive : confirmArchive),
      onOk: cencel => {
        cencel();
        handleClick(isArchive ? 'active' : 'archive');
      },
    });
  };

  if (isArchive) {
    return (
      <Button
        type="primary"
        onClick={confirmPopup}
        size="large"
        style={{ width: '100%', marginBottom: 16 }}
      >
        Восстановить сотрудника
      </Button>
    );
  } else {
    return (
      <Button
        className="add-employee__reset"
        onClick={confirmPopup}
        size="large"
        style={{ width: '100%' }}
        type="danger"
      >
        Архивировать сотрудника
      </Button>
    );
  }
};

export default BtnArchiveEmployee;
